import { format } from "date-fns-tz";
import { buildMatchPath } from "pages/PageConfigs";
import { MatchTimeContainer } from "./styles";
import { MatchesViewerTeamList } from "./Teams/List/MatchesViewerTeamList";
import { Match } from "model/Match/Match";
import { PlainNavLink } from "styles/elements";
import { FlexRow } from "styles/layout";

interface Props {
  match: Match;
  tournamentId: string;
}

export const MatchesViewerMatch = ({ match, tournamentId }: Props) => {
  const startDate = new Date(match.startTimeMs);
  return (
    <PlainNavLink to={buildMatchPath(match.id)}>
      <FlexRow>
        <MatchTimeContainer isDelayed={match.isDelayed}>
          <span>{format(startDate, "do MMM")}</span>
          <span>{format(startDate, "HH:mm")}</span>
          {match.isDelayed && <span>Delayed</span>}
        </MatchTimeContainer>
        <MatchesViewerTeamList match={match} tournamentId={tournamentId} />
      </FlexRow>
    </PlainNavLink>
  );
};
